export default __webpack_public_path__ + "static/media/logochat.ed490875.png";